import React, { useEffect } from 'react';
import useFetch from 'hooks/useFetch';
import { routes } from 'constants/config';
import Spinner from 'ui/Spinner';
import { Icon } from 'ui';
import LessonExpertView from './LessonExpertView';

function LessonExpertViewContainer({ match }) {
  const { lessonId } = match.params;
  const expertPath = routes.LESSON_OVERVIEW.EXPERT(lessonId);
  const suggestionsPath = routes.LESSON_OVERVIEW.EXPERT_SUGGESTIONS(lessonId);
  const { data, error, loading } = useFetch(expertPath);

  // Allow Page Error Boundary handles api errors
  useEffect(() => {
    if (error) {
      throw new Error(error);
    }
  }, [error]);

  return (
    <div id="experts">
      <h3 className="Module-heading SectionHeading">
        {t('expert.lesson.title')}
        <Icon
          name="info"
          className="Module-headingIcon"
          data-toggle="tooltip"
          data-original-title={t('expert.lesson.tooltip')}
        />
      </h3>
      {loading && (
        <div className="quicklist-item">
          <Spinner />
        </div>
      )}
      {!loading && (
        <LessonExpertView
          expertPath={expertPath}
          suggestionsPath={suggestionsPath}
          {...data}
        />
      )}
    </div>
  );
}

export default LessonExpertViewContainer;
